<template>
  <UILinkComponent
    v-if="name"
    :to="link"
    :target="resolvedTarget"
    class="btn btn-hover-animation"
  >
    <span class="hide sm-show">{{ name }}</span>

    <span class="btn-title-wrap sm-hide">
      <span
        v-for="variant in ['out', 'in']"
        :key="variant"
        :class="['btn-title', `btn-title--${variant}`]"
        :aria-hidden="variant === 'in' ? 'true' : undefined"
      >
        <span
          v-for="(word, index) in words"
          :key="index"
          class="btn-title-word"
          :style="{ transitionDelay: `${index * 30}ms` }"
        >
          {{ word }}&nbsp;
        </span>
      </span>
    </span>
  </UILinkComponent>
</template>

<script setup lang="ts">
  const props = defineProps<{
    link: string
    name: string
    target: string
  }>()

  // Check if the link is a view.asp link (for download links), which should open in a new tab otherwise it doesn't work properly
  const isViewAspLink = /view\.asp\?guid=[0-9a-f-]{36}/i.test(props.link ?? '')
  const resolvedTarget = computed(() => (isViewAspLink ? '_blank' : props.target))

  // Duplicated into an "out" (visible) and "in" (hidden below) copy so the hover animation
  // can slide the visible words up while the hidden copy slides into their place
  const words = computed(() => {
    const name = props.name?.trim()
    return name ? name.split(/\s+/) : []
  })
</script>
